export default __webpack_public_path__ + "media/images/favicon/web-app-manifest-192x192.png";